import { useTranslation } from 'react-i18next';
import { SKILLS_CATEGORIES } from '../data/skills';

export default function SkillFilter({ activeCategory, onCategoryChange }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap gap-2">
      <button
        onClick={() => onCategoryChange('all')}
        className={`px-4 py-2 font-mono text-xs uppercase tracking-wider border transition-colors ${
          activeCategory === 'all'
            ? 'bg-amber-500 text-black border-amber-500'
            : 'border-zinc-800 text-zinc-400 hover:border-zinc-600 hover:text-white'
        }`}
      >
        {t('skills_page.all_categories')}
      </button>
      {SKILLS_CATEGORIES.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onCategoryChange(cat.id)}
          className={`px-4 py-2 font-mono text-xs uppercase tracking-wider border transition-colors ${
            activeCategory === cat.id
              ? 'bg-amber-500 text-black border-amber-500'
              : 'border-zinc-800 text-zinc-400 hover:border-zinc-600 hover:text-white'
          }`}
        >
          {cat.icon} {cat.label}
        </button>
      ))}
    </div>
  );
}
